import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { Container, Segment } from 'semantic-ui-react';
import { Commons, UseStats } from 'components';
import update from 'react-addons-update';

import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class SikdaeUseStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pagerow: 15,
      totalcount: null,
      sort: {
        user: false,
        division: false,
        store: false,
        group: false,
        policy: false
      },

      staffModal: {
        open: false,
        size: 'large'
      },
      storeModal: {
        open: false,
        size: 'large'
      },
      staff: {
        name: '',
        id: ''
      },
      store: {
        name: '',
        id: ''
      }
    };
  }

  componentWillMount() {
    cm.propsInit(this.props);
    //식대 사용 통계 리스트
    this.usageStatList();
  }

  componentDidMount() {
    cm.mainTitle('식대 사용 통계');
  }
  shouldComponentUpdate(nextProps, nextState) {
    let result = true;

    const nCommonsProps = {
      dateType: nextProps.dateType,
      date: nextProps.date,
      depth: nextProps.depth,
      orgIdx: nextProps.orgIdx,
      groupIdx: nextProps.groupIdx,
      policyIdx: nextProps.policyIdx
    };

    const bCommonsProps = {
      dateType: this.props.dateType,
      date: this.props.date,
      depth: this.props.depth,
      orgIdx: this.props.orgIdx,
      groupIdx: this.props.groupIdx,
      policyIdx: this.props.policyIdx
    };

    if (JSON.stringify(nCommonsProps) !== JSON.stringify(bCommonsProps)) {
      result = false;
    }

    return result;
  }

  searchClick = (type) => {
    if (type === 'staff') {
      this.modalAction('open', true);
    } else {
      this.storeModalAction('open', true);
    }
  };

  modalAction = (type, dimmer) => {
    if (type === 'open') {
      this.staffSel(1, null);
    }

    this.setState({
      dimmer,
      staffModal: { open: dimmer }
    });
  };

  storeModalAction = (type, dimmer) => {
    if (type === 'open') {
      this.storeSel(1, null);
    }

    this.setState({
      dimmer,
      storeModal: { open: dimmer }
    });
  };

  staffSel = async (page, keyword) => {
    const { cmAPI } = this.props;

    const params = {
      page: page,
      pagerow: 10,
      keyword: keyword
    };

    try {
      await cmAPI.staffSel(params);
    } catch (e) {
      console.log('###### staffSel error : ', e);
    } finally {
    }
  };

  storeSel = async (page, keyword) => {
    const { cmAPI } = this.props;

    const params = {
      page: page,
      pagerow: 10,
      keyword: keyword,
      isactive: null
    };

    try {
      await cmAPI.storeSel(params);
    } catch (e) {
      console.log('###### storeSel error : ', e);
    } finally {
    }
  };

  choiceStaff = (data) => {
    this.setState({
      staff: {
        name: data ? data.staff.name : '',
        id: data ? data.staff.id : ''
      },
      staffModal: { open: false }
    });
  };

  choiceStore = (name, id) => {
    this.setState({
      store: {
        name: name,
        id: id
      },
      storeModal: { open: false }
    });
  };

  submitForm = async (e) => {
    e.preventDefault();

    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }

    await this.setState({ page: 1 });
    this.usageStatList();
  };

  usageStatList = async () => {
    const { date, dateType, depth, usageAPI, groupIdx, policyIdx, orgIdx } = this.props,
      { page, pagerow, sort, staff, store, totalcount } = this.state;

    let division = null;
    if (depth) {
      division = depth.two ? (depth.three ? depth.three : depth.two) : depth.one;
    }

    const params = {
      startdate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LLL'),
      enddate: date ? date.eDate : moment().format('LLL'),
      datetype: dateType ? dateType.value : 'MM',
      orgidx: sort.division ? (orgIdx ? orgIdx.value : null) : null,
      uid: sort.user ? staff.id : null,
      sid: sort.store ? store.id : null,
      groupidx: sort.group ? (groupIdx ? groupIdx.value : null) : null,
      policyidx: sort.policy ? (policyIdx ? policyIdx.value : null) : null,
      usersort: sort.user,
      divisionsort: sort.division,
      storesort: sort.store,
      groupsort: sort.group,
      policysort: sort.policy,
      page: page,
      pagerow: pagerow,
      totalcount: page !== 1 ? totalcount : null
    };

    usageAPI.usageStatTotal(params);
    await usageAPI.usageStatList(params);

    const { usageStat } = this.props;

    if (usageStat && usageStat.data) {
      const { paging } = usageStat.data;
      this.setState({ totalcount: paging.totalcount });
    }

    const { cmAPI } = this.props;

    cmAPI.changeExcel({
      excel: params
    });
  };

  pageClick = async (page) => {
    await this.setState({ page: page });
    this.usageStatList();
  };

  caseCheckboxAction = async (e, data, type) => {
    await this.setState({
      sort: update(this.state.sort, { $merge: { [type]: data.checked } })
    });

    if (type === 'group' && !data.checked) {
      await this.setState({
        sort: update(this.state.sort, { $merge: { ['policy']: data.checked } })
      });
    }
  };

  render() {
    const { usageStat } = this.props;
    const { page, pagerow, staffModal, storeModal, dimmer, staff, store, sort } = this.state;

    const modal = {
      open: staffModal.open,
      size: staffModal.size,
      dimmer: dimmer,
      close: this.modalAction
    };

    const modal2 = {
      open: storeModal.open,
      size: storeModal.size,
      dimmer: dimmer,
      close: this.storeModalAction
    };

    const sb = {
      fn: {
        choiceStaff: this.choiceStaff,
        choiceStore: this.choiceStore,
        caseCheckboxAction: this.caseCheckboxAction
      }
    };

    const listFn = {
      page: page,
      pagerow: pagerow,
      pageClick: this.pageClick
    };

    const modalFn = {
      staffSel: this.staffSel
    };

    let loading = '';
    if (!usageStat) {
      loading = <Commons.LoadingBar />;
    }

    return (
      <main className="sus">
        {loading}

        <UseStats.SearchBox
          modalAction={this.modalAction}
          storeModalAction={this.storeModalAction}
          staff={staff}
          sort={sort}
          storeinfo={store}
          fn={sb.fn}
          submitForm={this.submitForm}
        />

        <UseStats.StatsList listFn={listFn} sort={sort} />
        {staffModal.open ? (
          <Commons.StaffSearchModal modal={modal} staffSel={this.staffSel} choiceEvent={this.choiceStaff} />
        ) : null}

        <Commons.StoreSearchModal modal={modal2} storeSel={this.storeSel} choiceEvent={this.choiceStore} />
      </main>
    );
  }
}

SikdaeUseStats = connect(
  (state) => ({
    //common function call
    dateType: state.commons.dateType,
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    division: state.commons.division,
    depth: state.commons.depth,
    orgIdx: state.commons.orgIdx,

    staffList: state.commons.staff,
    storeList: state.commons.companyStore,

    groupIdx: state.commons.group,
    policyIdx: state.commons.policy,
    //usage function
    usageStat: state.usage.usageStats
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        staffSel: cm_action.StaffSel,
        storeSel: cm_action.StoreList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    ),

    usageAPI: bindActionCreators(
      {
        usageStatList: usg_action.UsageStatsList,
        usageStatTotal: usg_action.UsageStatsTotal
      },
      dispatch
    )
  })
)(SikdaeUseStats);

export default SikdaeUseStats;
